import CrowdfundingPage from './crowdfunding_page'
import { connect } from 'react-redux'
import { fromVeniceSelector } from 'redux/selectors/venice'
import { getCrowdfundingEntryBanner } from 'redux/selectors/campaign'

const mapStateToProps = (state, { showHeader, showFooter }) => {
  const fromVenice = fromVeniceSelector()(state)
  if (fromVenice) {
    showHeader = false
    showFooter = false
  }
  return {
    showHeader,
    showFooter,
    isLoggedIn: state.login_info && state.login_info.logged_in,
    allowEntryBanner: getCrowdfundingEntryBanner(state),
  }
}
export default connect(mapStateToProps)(CrowdfundingPage)
